module.exports = __webpack_public_path__ + "node.eWMJnXDC.svg";